module.exports = __webpack_public_path__ + "img/logo.fe5839b2.svg";